import { Dialog } from '@headlessui/react';
import type { ReactNode } from 'react';

export interface ModalProps {
  isOpen: boolean;
  onCancelModal: () => void;
  children: ReactNode;
  className?: string;
  maxWidth?: string;
  testId?: string;
}

export const Modal = ({
  isOpen,
  children,
  className = '',
  onCancelModal,
  maxWidth = 'lg',
  testId = 'modal'
}: ModalProps) => {
  const maxWidthTW = `max-w-screen-${maxWidth}`;

  return (
    <Dialog open={isOpen} className={className} onClose={onCancelModal}>
      <div
        className="text-soClean-100 outline-hidden focus:outline-hidden fixed inset-0 z-[52] flex items-center justify-center"
        data-testid={testId}
      >
        <Dialog.Panel
          as="div"
          className={`relative size-fit rounded-md ${maxWidthTW}`}
        >
          {children}
        </Dialog.Panel>
      </div>
      <div
        data-testid="modal-overlay"
        className="bg-soFresh-110 fixed inset-0 z-[51] opacity-80 blur-xl"
      />
    </Dialog>
  );
};
